import { createCompositeMap } from '../composites';

import { modalActionCreators } from './modalState';
import { selectModalComponentType } from './selectors';

export const createModalCompositeMap = modalComposites =>
  createCompositeMap(selectModalComponentType, { modalActions: { ...modalActionCreators } }, modalComposites);
